import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BUSINESS_INDUSTRIES } from "@/api/business/types";

interface BusinessBasicInfoProps {
  name: string;
  industry: string;
  industry_enum?: string;
  updateBusinessData: (key: string, value: string) => void;
}

const BusinessBasicInfo: React.FC<BusinessBasicInfoProps> = ({ 
  name, 
  industry, 
  industry_enum, 
  updateBusinessData 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="business-name">Business Name <span className="text-red-500">*</span></Label>
        <Input
          id="business-name"
          placeholder="Acme Inc."
          value={name}
          onChange={(e) => updateBusinessData("name", e.target.value)}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="industry">Industry <span className="text-red-500">*</span></Label>
        <Select 
          value={industry_enum || industry}
          onValueChange={(value) => {
            updateBusinessData("industry", value);
            updateBusinessData("industry_enum", value);
          }}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select an industry" />
          </SelectTrigger>
          <SelectContent>
            {BUSINESS_INDUSTRIES.map((industry) => (
              <SelectItem key={industry} value={industry}>
                {industry}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default BusinessBasicInfo;
